import { CerFormAdapter } from '@form/cer-form-adapter';
import { ColorCss, FieldCell, FieldEditChangedArgs, FieldWidthEnum } from '../../../cer/cer-data/cer-data-types';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';

export class ProductBOMForm extends CerFormAdapter {

    public override viewSetInit(viewSet: CerFormViewSet) {
        viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 45);
        const view = ProductBOMForm.viewGet();
        viewSet.viewAdd(view);
        const viewLines = ProductBOMForm.viewLinesGet();
        viewLines.mandatory = true;
        viewSet.viewAdd(viewLines, view);
    }

    private static viewGet(): CerFormView {
        const view: CerFormView = new CerFormView();

        view.viewMetadata = {
            name: 'titel-bundles', dataApiName: 'ProductBOM', text: 'Bundles', textSingular: 'Bundle',
            primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history'], titleFields: ['num', 'name']
        };

        view.fieldMetadata = [
            {
                name: 'num', text: 'ISBN bundle', tooltipText: 'ISBN på bundle/bogpakken', allowEdit: false, allowEditOnAdd: true, required: true, foreignKeyType: 'refDataProduct',
                onEditChanged: (e) => { ProductBOMForm.editNum(e) }
            },
            { name: 'name', text: 'Titel', required: true },
            {
                name: 'onhandAvailableQty', text: 'Lager', format: 'Integer', widthType: FieldWidthEnum.XXXS,
                allowEdit: false, allowEditOnAdd: false, visibleEdit: false, visibleAdd: false, allowFiltering: false, allowSorting: false,
                onQueryCellInfo: (e) => { ProductBOMForm.colorOnhand(e) }
            },
            {
                name: 'onhandAvailableBOMQty', text: 'Indhold lager', format: 'Integer', widthType: FieldWidthEnum.XXXS,
                allowEdit: false, allowEditOnAdd: false, visibleEdit: false, visibleAdd: false, allowFiltering: false, allowSorting: false,
                onQueryCellInfo: (e) => { ProductBOMForm.colorOnhand(e) }
            },

        ];
        return view;
    }

    private static viewLinesGet(): CerFormView {
        const view: CerFormView = new CerFormView();

        view.viewMetadata = {
            name: 'titel-bundle-indhold', dataApiName: 'ProductBOMLine', text: 'Bundle indhold',
            primaryKey: 'id', parentPrimaryKey: 'num', parentForeignKey: 'productBOM', baseFields: ['id', 'history'], titleFields: ['product', 'name']
        };

        view.fieldGroupMetadata = [
            { idx: 1, tabIdx: 0, name: 'identification', text: 'Identifikation', fields: ['id', 'productBOM', 'product', 'name'], width: 240 },
            { idx: 2, tabIdx: 0, name: 'period', text: 'Periode aktiv', fields: ['fromDate', 'toDate'] },
        ];

        view.fieldMetadata = [
            {
                name: 'productBOM', text: 'ISBN bundle', tooltipText: 'ISBN på bundlen',
                allowEdit: false, required: true, visible: false, visibleAdd: true, visibleEdit: true, orderBy: 'Ascending', orderByPriority: 1,
                foreignKeySearchFields: ['num', 'name'], foreignKeySearchOperators: ['contains', 'contains']
            },
            {
                name: 'product', text: 'ISBN indeholdt', tooltipText: 'ISBN på indhold i bundle',
                allowEdit: false, allowEditOnAdd: true, required: true, orderBy: 'Ascending', orderByPriority: 2,
                foreignKeyType: 'refDataProduct',
                onEditChanged: (e) => { ProductBOMForm.editProduct(e) }
            },
            { name: 'name', text: 'Titel', required: true },
            { name: 'qty', text: 'Antal', format: 'Integer', required: true, defaultValue: 1, widthType: FieldWidthEnum.XXXS },
            {
                name: 'onhandAvailableQty', text: 'Lager', format: 'Integer', widthType: FieldWidthEnum.XXXS,
                allowEdit: false, allowEditOnAdd: false, visibleEdit: false, visibleAdd: false, allowFiltering: false, allowSorting: false,
                onQueryCellInfo: (e) => { ProductBOMForm.colorOnhand(e) }
            },
            { name: 'fromDate', text: 'Fra dato', format: 'DateShort' },
            { name: 'toDate', text: 'Til dato', format: 'DateShort' }
        ];
        return view;
    }

    private static colorOnhand(e: QueryCellInfoEventArgs) {
        const value = FieldCell.cellInfoValue(e);
        if (value == 0 || value == 0) {
            ColorCss.backgroundClass(e.cell as HTMLElement, 'red');
        }
    }

    private static editNum(e: FieldEditChangedArgs) {
        var product: any = e.itemData;
        if (product) {
            var nameValue: string = product.name;
            var nameInput = e.editService?.fieldInput('name');
            if (nameInput && (nameValue?.length > 0)) {
                e.editService?.inputValueSet(nameInput, nameValue);
            }
        }
    }

    private static editProduct(e: FieldEditChangedArgs) {
        var product: any = e.itemData;
        if (product) {
            var nameValue: string = product.name;
            var nameInput = e.editService.fieldInput('name');
            if (nameInput && (nameValue?.length > 0)) {
                e.editService.inputValueSet(nameInput, nameValue);
            }
        }
    }
}
